import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default () => {
  const slider = document.querySelector('.er_awards__slider');
  if (!slider) {
    return;
  }

  new Swiper('.er_awards__slider', {
    // grabCursor: true,
    navigation: {
      nextEl: '.er_awards__inner__next, .er_awards__inner__arrows__next, .er_awards .er_new-reviews__inner__next',
      prevEl: '.er_awards__inner__prev, .er_awards__inner__arrows__prev, .er_awards .er_new-reviews__inner__prev',
    },
    pagination: {
      el: '.er_awards__pagination',
      clickable: true,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 40,
    breakpoints: {
      768: {
        spaceBetween: 60,
      },
      1024: {
        spaceBetween: 80,
      },
    },
  });
};
